module.exports = __webpack_public_path__ + "static/media/licious.5c58958e.svg";